import React, { useCallback, useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { Field, FieldProps, Form as FormikForm, Formik } from 'formik'

import {
  Form,
  WishesFormProps,
  WishesProps,
  wishesForPage1,
  wishesForPage2,
  wishesForPage3,
  LayoutItem,
  WishesFieldType,
} from '../../../ana-toolbox'
import { FormLayout } from '../../components/form-layout/form-layout'
import { SubmitButton } from '../../components/submit-button/submit-button'
import { WishesRatingField } from '../../components/wishes-rating-field/wishes-rating-field'
import { WishesToggleField } from '../../components/wishes-toggle-field/wishes-toggle-field'
import { wishesSettings } from '../../utils/config/wishes'
import { validationSchema } from '../../utils/fields/wishesAndExpectations'
import { getFormInitialErrors } from '../../utils/helpers/getFormInitialErrors'

export const WishesForm = ({
  initialValues = {},
  wishes = [],
  onSubmit,
  loading,
  innerRef,
  portalAttr,
}: WishesFormProps) => {
  const { t } = useTranslation()

  const layout = useMemo(() => {
    return wishes.map((wish): LayoutItem => {
      return {
        type: 'custom',
        key: wish.key,
        xs: 12,
        render: ({ values: { wishesAndExpectations = [] } }) => {
          const wishSettings = wishesSettings[wish.key]

          if (wishSettings?.visibleWhen?.(wishesAndExpectations) === false) return null

          const toggleComponent = <WishesToggleField wishKey={wish.key} label={`field.${wish.key}`} />

          const ratingComponent = (
            <WishesRatingField required={wishSettings?.required} wishKey={wish.key} label={`field.${wish.key}`} />
          )

          if (wishSettings?.type) {
            return wishSettings.type === WishesFieldType.RATING ? ratingComponent : toggleComponent
          }

          if (wish.flag !== undefined) {
            return toggleComponent
          }

          if (wish.score !== undefined) {
            return ratingComponent
          }

          return null
        },
      }
    })
  }, [wishes])

  const handleSubmit = useCallback(
    (values: Partial<Form>) => {
      onSubmit(values)
    },
    [onSubmit]
  )

  const submitButton = (
    <Field>
      {(props: FieldProps) => {
        return (
          <SubmitButton onClick={() => props.form.submitForm()} disabled={!props.form.isValid} loading={loading}>
            {t('next')}
          </SubmitButton>
        )
      }}
    </Field>
  )

  const currentKeys = wishes.map((w) => w.key)

  return (
    <Formik
      initialErrors={getFormInitialErrors(validationSchema(currentKeys), initialValues)}
      validationSchema={validationSchema(currentKeys)}
      innerRef={innerRef}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      <FormikForm>
        <FormLayout portalAttr={portalAttr} items={layout} submitButton={submitButton} />
      </FormikForm>
    </Formik>
  )
}

export const WishesForm1 = (props: WishesProps) => <WishesForm {...props} wishes={props.wishes || wishesForPage1} />

export const WishesForm2 = (props: WishesProps) => <WishesForm {...props} wishes={props.wishes || wishesForPage2} />

export const WishesForm3 = (props: WishesProps) => <WishesForm {...props} wishes={props.wishes || wishesForPage3} />
